// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlaidInstitutionDto
 */
export interface IPlaidInstitutionDto {
    /**
     * 
     * @type {string}
     * @memberof IPlaidInstitutionDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IPlaidInstitutionDto
     */
    institution_id?: string;
}

/**
 * Check if a given object implements the IPlaidInstitutionDto interface.
 */
export function instanceOfIPlaidInstitutionDto(value: object): value is IPlaidInstitutionDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function IPlaidInstitutionDtoFromJSON(json: any): IPlaidInstitutionDto {
    return IPlaidInstitutionDtoFromJSONTyped(json, false);
}

export function IPlaidInstitutionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlaidInstitutionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'institution_id': json['institution_id'] == null ? undefined : json['institution_id'],
    };
}

export function IPlaidInstitutionDtoToJSON(json: any): IPlaidInstitutionDto {
    return IPlaidInstitutionDtoToJSONTyped(json, false);
}

export function IPlaidInstitutionDtoToJSONTyped(value?: IPlaidInstitutionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'institution_id': value['institution_id'],
    };
}

